import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<Theme>()((theme) => ({
  expanded: {
    transform: 'rotate(180deg)',
  },
  icon: {
    transition: 'transform .3s',
  },
}));
export default useStyles;
